import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

type Params = {
  onHistoryChange?: (href: string) => void;
  onFirstPageLoad?: (href: string) => void;
  onSpaPageChange?: (href: string) => void;
};

export const useHistoryChange = (payload: Params) => {
  const { onHistoryChange, onFirstPageLoad, onSpaPageChange } = payload;
  const history = useHistory();

  useEffect(() => {
    onHistoryChange && onHistoryChange(document.location.href);
    onFirstPageLoad && onFirstPageLoad(document.location.href);

    const unlisten = history.listen((location: any) => {
      onHistoryChange &&
        onHistoryChange(
          `${document.location.origin}${location.pathname}${location.search}`
        );
      onSpaPageChange &&
        onSpaPageChange(
          `${document.location.origin}${location.pathname}${location.search}`
        );
    });

    return () => {
      unlisten();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
